<template>
    <div class="page-notice-detail">
        <div class="business-detail">
            <el-row :gutter="18">
                <el-col :span="18">
                    <card class="paper" v-loading="loadingController">
                        <div class="title">
                            {{ detail.Data_title }}
                        </div>

                        <table
                            class="info-table"
                            cellpadding="0"
                            cellspacing="0"
                        >
                            <tr>
                                <td>
                                    <p>项目编号：{{ detail.zbprocode }}</p>
                                </td>
                                <td>
                                    <p>招标方式：{{ detail.zbfsname }}</p>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <p>项目地点：{{ detail.cityname }}</p>
                                </td>
                                <td>
                                    <p>所属行业：{{ detail.hyname }}</p>
                                </td>
                            </tr>
                        </table>

                        <qingdan-detail v-if="detail.type == '清单采购'" :dataInfo="detail.resultMap"></qingdan-detail>

                        <div
                            class="context rich-text"
                            v-html="detail.Data_content"
                        ></div>

                        <table-hxrgs :data="detail"></table-hxrgs>

                        <file-download :data="detail"></file-download>

                        <link-paper v-if="detail.type != '清单采购'" :data="detail"></link-paper>
                    </card>
                </el-col>

                <el-col :span="6">
                    <card
                        class="time-card right-card"
                        v-loading="loadingController"
                    >
                        <div
                            slot="title"
                            class="title"
                            :style="{ color: myColor }"
                        >
                            时间汇总
                        </div>

                        <el-timeline class="time-line">
                            <el-timeline-item
                                v-if="detail.Data_fsks || detail.Data_fsjz"
                                :color="myColor"
                            >
                                <div class="time-line-item">
                                    <div
                                        class="title"
                                        :style="{ color: myColor }"
                                    >
                                        文件获取时间
                                    </div>
                                    <p>开始：{{ detail.Data_fsks }}</p>
                                    <p>截止：{{ detail.Data_fsjz }}</p>
                                </div>
                            </el-timeline-item>

                            <el-timeline-item
                                v-if="detail.Data_tjjz"
                                :color="myColor"
                            >
                                <div class="time-line-item">
                                    <div
                                        class="title"
                                        :style="{ color: myColor }"
                                    >
                                        投标文件递交截止时间
                                    </div>
                                    <p>截止：{{ detail.Data_tjjz }}</p>
                                </div>
                            </el-timeline-item>
                        </el-timeline>
                    </card>

                    <card class="guide-card right-card">
                        <div
                            slot="title"
                            class="title"
                            :style="{ color: myColor }"
                        >
                            投标指南
                        </div>

                        <div class="guide-list">
                            <div class="item">
                                <img src="/images/notice/file1.png" alt="" />
                                <div class="text">获取招标文件</div>
                            </div>

                            <div class="item">
                                <img src="/images/notice/file2.png" alt="" />
                                <div class="text">递交/上传投标文件</div>
                            </div>
                        </div>
                    </card>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
import { buildTdk } from '@config/tdk';
import appNode from '@js/app-node';

import Card from '@components/sys/card';
import TableHxrgs from './components/table-hxrgs';
import FileDownload from './components/file-download';
import LinkPaper from './components/link-paper';

import QingdanDetail from './components/qingdan-detail';

export default {
    components: {
        Card,
        TableHxrgs,
        FileDownload,
        LinkPaper,
        QingdanDetail
    },
    head() {
        var tdk = buildTdk('notice');
        var {
            Data_title,
            Data_content,
            title_page,
            zbfsname,
            hyname,
            cityname,
        } = this.detail;

        Data_content = Data_content || '';

        return {
            title: `${Data_title}_${tdk.title}·${tdk.webName}`,
            meta: [
                {
                    hid: 'description',
                    name: 'description',
                    content: Data_content.replace(/\<((?:.|\n)+?)\>/gi, '')
                        .replace(/\s/g, '')
                        .slice(0, 100),
                },
                {
                    hid: 'keywords',
                    name: 'keywords',
                    content: `${Data_title},${Data_content},${title_page},${zbfsname},${hyname},${cityname},`,
                },
            ],
        };
    },

    async asyncData(context) {
        let detail = {
            Data_title: '',
            Data_content: '',
            title_page: '',
            zbfsname: '',
            hyname: '',
            cityname: '',
        };

        var infoid = context.params.guid,
            categoryid = context.query.categoryid || null,
            bdcode = context.query.bdcode || null,
            url = `${context.store.state.api.webUrl}/index/information/getjyinfodetail.json`,
            search = {
                infoid,
                categoryid,
            };

        if (bdcode) {
            url = `${context.store.state.api.webUrl}/index/information/getgginfodetail.json`;
            search = {
                bdcode,
            };
        }

        try {
            detail = await appNode.ssrReq
                .call(context, url, search);
        } catch (e) {
            console.error(e);
        }

        return {
            detail,
        };
    },

    data() {
        return {
            // detail: {},
            loadingController: false,
            myColor: this.webInfo.themeColor,
        };
    },
    methods: {},
    mounted() {},
};
</script>

<style lang="scss" scoped>
.page-notice-detail {
    // background-color: #f8f9fb;
    // border-top: 1px solid #f8f9fb;
}

$tableBorder: 1px #dfdfdf solid;

.business-detail {
    width: 1200px;
    margin: 0 auto;
    padding: 20px 0;

    .paper {
        min-height: 600px;
        background-color: #f8f9fb;
        box-shadow: 0px 9px 9px 0px #e8eaef;
        border: solid 2px #ffffff;
        margin-bottom: 10px;

        .title {
            font-size: 18px;
            color: #262626;
            text-align: center;
            padding-bottom: 24px;
            border-bottom: solid 1px #dfdfdf;
            margin-bottom: 1em;
        }

        .info-table {
            width: 100%;
            border-top: $tableBorder;
            border-left: $tableBorder;
            margin-bottom: 1em;

            td {
                border-right: $tableBorder;
                border-bottom: $tableBorder;
                padding: 1em;
            }
        }
    }

    .context {
        line-height: 2em;
        color: #262626;
    }

    .right-card {
        background-color: #f8f9fb;
        box-shadow: 0px 9px 9px 0px #e8eaef;
        border: solid 2px #ffffff;

        .title {
            color: #262626;
            font-size: 18px;
            font-weight: bold;
        }

        & + .right-card {
            margin-top: 12px;
        }
    }

    .time-card {
        .time-line {
            padding-left: 2px;
            padding-top: 8px;

            ::v-deep {
                .el-timeline-item__wrapper {
                    padding-left: 24px;
                    top: -6px;
                }
            }

            .time-line-item {
                background-color: #ebebeb;
                padding: 12px;
                color: #262626;
                position: relative;

                &:before {
                    content: '';
                    display: block;
                    width: 0.8em;
                    height: 0.8em;
                    position: absolute;
                    left: 0;
                    top: 1em;
                    transform: translate(-50%, -50%) rotate(45deg);
                    background-color: #ebebeb;
                }

                .title {
                    font-weight: bold;
                    margin-bottom: 10px;
                }

                p {
                    & + p {
                        margin-top: 10px;
                    }
                }
            }
        }
    }

    .guide-card {
        .guide-list {
            overflow: hidden;
            background-image: url('/images/notice/arrow.png');
            background-position: center top;
            background-repeat: no-repeat;

            .item {
                text-align: center;

                .text {
                    line-height: 1em;
                    margin-top: 12px;
                }

                &:first-child {
                    float: left;
                }

                &:last-child {
                    float: right;
                }
            }
        }
    }
}
</style>